// extracted by mini-css-extract-plugin
export var body = "_qg-8";
export var button = "_qg-0";
export var closeButton = "_qg-5";
export var content = "_qg-3";
export var empty = "_qg-f";
export var grid = "_qg-c";
export var header = "_qg-4";
export var icon = "_qg-1";
export var option = "_qg-d";
export var optionSelected = "_qg-e";
export var overlay = "_qg-2";
export var searchIcon = "_qg-a";
export var searchInput = "_qg-b";
export var searchWrapper = "_qg-9";
export var title = "_qg-6";
export var visuallyHidden = "_qg-7";